// theme constant
export const gridSpacing = 1.875;
export const drawerWidth = 265;
export const appDrawerWidth = 320;
